export type SenderEnum = 'Human' | 'ai';

export interface ChatMessage {
  id: number;
  text: string;
  sender: SenderEnum;
  created_at: string;
}

export interface SendMessagePayload {
  user_input: string;
}

export interface TripPlannerSendPayload {
  message: string;
  thread_id?: string;
  timezone: string;
}

export interface TripPlannerApiResponse {
  message: string;
  thread_id: string;
}

export interface TripPlannerMessage {
  id: number;
  text: string;
  sender: SenderEnum;
  created_at: string;
  thread_id?: string;
}

export interface ChatState {
  messages: ChatMessage[];
  isLoading: boolean;
  error: string | null;
}

export type ChatMode = 'normal' | 'trip_planner';

export type QuickActionType = 'trip_planner' | 'packing_lists' | 'local_customs';

export interface QuickAction {
  type: QuickActionType;
  label: string;
  message: string;
}

export const quickActionsTypes: Record<QuickActionType, QuickActionType> = {
  trip_planner: 'trip_planner',
  packing_lists: 'packing_lists',
  local_customs: 'local_customs',
};

export interface AIAssistantProps {
  tripId: string;
  onClose: () => void;
}

export interface ChatInputFormData {
  message: string;
}

export type AITripPlanningSessionStatus =
  | 'clarifying'
  | 'awaiting_preview'
  | 'preview_ready'
  | 'finalized'
  | 'failed'
  | string;

export interface AITripPlanningStructuredInput {
  name: string;
  departure_point: string;
  destination_country: string;
  start_date: string;
  end_date: string;
  adults: number;
  children: number;
  buddy_ids: number[];
}

export interface AITripPlanningCreateSessionPayload {
  structured: AITripPlanningStructuredInput;
}

export interface AITripPlanningAnswerObject {
  [key: string]: string | number | boolean | string[] | null;
}

export interface AITripPlanningSubmitAnswersPayload {
  answers: AITripPlanningAnswerObject[];
}

export interface AITripPlanningFinalizePayload {
  save_as: 'trip' | 'sample_trip';
}

export interface AITripPlanningOption {
  value: string;
  label: string;
}

export type AITripPlanningQuestionType = 'text' | 'single_choice' | 'multi_choice';

export interface AITripPlanningQuestion {
  id: string;
  prompt: string;
  type: AITripPlanningQuestionType;
  required?: boolean;
  options?: AITripPlanningOption[];
  raw?: Record<string, unknown>;
}

export interface AITripPlanningSessionResponse {
  id: number;
  status: AITripPlanningSessionStatus;
  input_method: string;
  initial_payload: unknown;
  qa_rounds: unknown;
  pending_questions: unknown;
  preview_payload: unknown;
  preset_key?: string | null;
  finalized_trip?: number | null;
  finalized_idea?: number | null;
  created_at: string;
  updated_at: string;
}
